<template>
  <label class="block text-sm leading-tight font-semibold text-wt-gray-d">
    <slot />
  </label>
</template>
